const WatkinsGraphic = () => (
  <div className='doodle-watkins'>
    <div className='outerOval'>
      <div className='innerOval' />
      <div className='watkins' />
    </div>
  </div>
)

export default WatkinsGraphic
